export default class InactiveSessionError extends Error {
    constructor() {
        super('Session is inactive or expired. Please log in again.');
    }
}
